import { Alert, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useCompanyDocumentsLanguage } from "../i18n/CompanyDocumentsLanguageContext";
import { getReviewFile } from "../service/DocumentReviewService";

export default function DocumentPreview({ record }) {
  const { t } = useCompanyDocumentsLanguage();
  const invalidPdfMessage = t("adminReview.documentPreview.invalidPdf");
  const unavailableMessage = t("adminReview.documentPreview.unavailable");
  const [url, setUrl] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    let objectURL;
    (async () => {
      try {
        const blob = await getReviewFile(record.id, "inline");
        const signature = await blob.slice(0, 5).text();
        if (blob.type !== "application/pdf" || signature !== "%PDF-")
          throw new Error(invalidPdfMessage);
        if (!active) return;
        objectURL = URL.createObjectURL(blob);
        setUrl(objectURL);
      } catch (e) {
        if (active) setError(e.message || unavailableMessage);
      }
    })();
    return () => { active = false; if (objectURL) URL.revokeObjectURL(objectURL); };
  }, [record.id, invalidPdfMessage, unavailableMessage]);
  if (error) return <Alert severity="error">{error}</Alert>;
  if (!url) return <div aria-label={t("adminReview.documentPreview.loading")}><CircularProgress size={24} /></div>;
  return <iframe title={t("adminReview.documentPreview.title", { version: record.version })} src={url} style={{ width: "100%", height: "55vh", border: "1px solid #ddd" }} />;
}
